import '../stylesheets/Loading.css';

export function Loading() {
  return (
    <div className='Loading'>
      <div className='lds-spinner'>
        <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
      </div>
    </div>
  )
}
